<template>
  <Box>
    <template #handle>
      <Btn @click="$router.go(-1)">返回</Btn>
    </template>
    <template #content>
      <div class="table_main">
        <div class="content">
          <Table :datas="tableData" :heads="tableHead" :selection="false" :loading="loading">
            <template #handle="data">
              <div class="table_cell">
                <span v-if="data.head.handle == 'index'">{{
                    (pageData.page - 1) * pageData.pageSize + data.index
                }}</span>
                <span v-if="data.head.handle == 'status'" :class="['pre']">
                  <span class="_pre" :style="{
                    background: (
                      sbstate.find((a) => a.value == data.data.sbstate) || {}
                    ).color,
                  }"></span>
                  <span>{{ data.data.sbstate }}</span>
                </span>
                <div v-if="data.head.handle == 'btns'">
                  <Btn type="text" @click="handleItem(data.data, '修改详情')">修改</Btn>
                </div>
              </div>
            </template>
          </Table>
          <el-pagination class="page" background layout="total, prev, pager, next" :total="pageData.total"
            :current-page.sync="pageData.page"  @current-change="getList">
          </el-pagination>
        </div>
      </div>
      <Drawer :open="open" @changeOpen="changeOpen" :drawerTitle="drawerTitle">
        <template #content>
          <el-form :model="addForm" ref="addForm" :rules="rules" label-width="130px" class="demo-ruleForm formBox">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="部署企业：" prop="companyname">
                  <el-input size="small" v-model="addForm.companyname" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="生产线：" prop="sccode">
                  <el-input size="small" v-model="addForm.sccode" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="连接类型：" prop="ljlx">
                  <el-select size="small" v-model="addForm.ljlx">
                    <el-option v-for="item in ljlxs" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="IP地址：" prop="ipaddress">
                  <el-input size="small" v-model="addForm.ipaddress"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="端口号：" prop="hostaddress">
                  <el-input size="small" v-model="addForm.hostaddress"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="经度坐标：" prop="jd">
                  <el-input size="small" v-model="addForm.jd"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="纬度坐标：" prop="wd">
                  <el-input size="small" v-model="addForm.wd"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="启用时间：" prop="uptime">
                  <el-date-picker size="small" v-model="addForm.uptime" type="date" placeholder="选择日期"
                    format="yyyy-MM-dd" value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="修改时间：" prop="updateTime">
                  <el-date-picker size="small" v-model="addForm.updateTime" type="date" placeholder="选择日期"
                    format="yyyy-MM-dd" value-format="yyyy-MM-dd" disabled>
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="操作人：" prop="createUser">
                  <el-input size="small" v-model="addForm.createUser" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </template>
        <template #footer>
          <Btn type="blue" @click="commitData">提交</Btn>
          <Btn @click="closeDrawer">取消</Btn>
        </template>
      </Drawer>
    </template>
  </Box>
</template> 

<script>
import { sbstate, ljlxs } from "@/utils/status";
import { sbDeployGl, edit } from "@/api/DeviceManagement";
import drawerMixins from "@/components/drawer/drawer";
import rules, { } from '@/utils/formRules';
export default {
  mixins: [drawerMixins],
  data() {
    return {
      pageData: {
        total: 0,
        page: 1,
        pageSize: 10,
      },
      loading: false,
      sbstate: sbstate,
      ljlxs: ljlxs,
      queryParams: {
        nnc: "",
        companyname: "",
        qy: "",
        sccode: "",
        yyzt: "",
      },
      rules: {
        ipaddress: rules.ipaddress,
        hostaddress: rules.hostaddress,
        jd: rules.jd,
        wd: rules.wd,
      },
      tableData: [],
      tableHead: [
        {
          prop: "xh",
          label: "序号",
          handle: "index",
          width: 50,
          textAlign: "right",
        },
        {
          prop: "uptime",
          label: "启用时间",
          minWidth: 100,
        },
        {
          prop: "companyname",
          label: "部署企业",
        },
        {
          prop: "companycode",
          label: "企业代码",
        },
        {
          prop: "sccode",
          label: "部署生产线",
        },
        {
          prop: "ljlx",
          label: "链接类型",
        },
        {
          prop: "ipaddress",
          label: "IP地址",
        },
        {
          prop: "hostaddress",
          label: "端口号",
        },
        {
          prop: "jd",
          label: "经度坐标",
        },
        {
          prop: "wd",
          label: "纬度坐标",
        },
        {
          prop: "updateTime",
          label: "修改时间",
          minWidth: 100,
        },
        {
          prop: "createUser",
          label: "操作人",
        },
        {
          prop: "cz",
          label: "操作",
          handle: "btns",
          fixed: "right",
        },
      ],
      addForm: {
        companyname: "",
        sccode: "",
        ljlx: "",
        ipaddress: "",
        hostaddress: "",
        jd: "",
        wd: "",
        uptime: "",
        updateTime: "",
        createUser: "",
      },
      initAddForm: {
        companyname: "",
        sccode: "",
        ljlx: "",
        ipaddress: "",
        hostaddress: "",
        jd: "",
        wd: "",
        uptime: "",
        updateTime: "",
        createUser: "",
      },
      drawerTitle: "修改详情",
    };
  },
  methods: {
    handleItem(data, drawerTitle) {
      this.drawerTitle = drawerTitle;
      this.addForm = {
        ...this.addForm,
        ...data,
      };
      if (drawerTitle === "修改详情")
        this.addForm.createUser = this.$store.state.userStore.userMsg.userName;
      this.changeOpen();
    },

    commitData() {
      this.$refs.addForm.validate(valid => {
        if (!valid) return false
        if (this.drawerTitle == "新增设备") {
          const params = {
            ...this.addForm,
          };
          delete params.updateTime;
          addDevice(this.addForm).then((res) => {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.addForm = {
              ...this.initAddForm,
            };
            this.changeOpen();
            this.getList();
          });
        } else if (this.drawerTitle == "修改详情") {
          const params = {
            ...this.addForm,
          };
          delete params.updateTime;
          edit(params).then((res) => {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.addForm = {
              ...this.initAddForm,
            };
            this.changeOpen();
            this.getList();
          });
        }
      })
    },
    getList() {
      this.loading = true
      const params = {
        id: this.$route.query.sbId,
      };
      sbDeployGl(params)
        .then((res) => {
          this.pageData.total = res.data.count;
          res.data.list.forEach((item) => {
            item.uptime = item.uptime?.substr(0, 10) || "";
            item.updateTime = item.updateTime?.substr(0, 10) || "";
          });
          this.tableData = res.data?.list || [];
          this.loading = false
        })
        .catch((err) => {
          this.pageData.total = 0;
          this.tableData = [];
          this.loading = false
        });
    },
  },
  created() {
    this.getList();
  },
};
</script>